import { render, staticRenderFns } from "./ProfilePreferences.vue?vue&type=template&id=0ad21fe0&scoped=true&"
import script from "./ProfilePreferences.vue?vue&type=script&lang=js&"
export * from "./ProfilePreferences.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePreferences.vue?vue&type=style&index=0&id=0ad21fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad21fe0",
  null
  
)

export default component.exports